import script from "./RouteStop.vue?vue&type=script&setup=true&lang=js"
export * from "./RouteStop.vue?vue&type=script&setup=true&lang=js"

import "./RouteStop.vue?vue&type=style&index=0&id=78fe6f2e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78fe6f2e"]])

export default __exports__